export const COMPONENT_NAME = "history-filters";
